export function centimesToCurrency(amount) {
  return amount / 100 + ' €';
}
